/* Scope & Field: cookie consent helpers for Shopify's own cookie banner (Settings, Customer privacy).
   1. The footer "Cookie settings" link reopens the banner's preferences panel so a visitor can change or
      withdraw consent at any time. It stays hidden until Shopify has put the banner on the page, which
      happens only where the banner is switched on for the visitor's region.
   2. Klaviyo stops tracking when marketing consent is declined, but leaves its __kla_id cookie behind
      if the visitor had accepted earlier (seen in testing, 23 October 2026). When marketing consent is
      "no", this removes that cookie, on page load and as soon as the visitor changes their choice. */
(function () {
  const KLAVIYO_COOKIES = ['__kla_id'];

  function clearKlaviyoCookies() {
    const host = window.location.hostname.replace(/^www\./, '');
    KLAVIYO_COOKIES.forEach((name) => {
      if (document.cookie.split('; ').some((c) => c.indexOf(name + '=') === 0)) {
        [null, host, '.' + host].forEach((domain) => {
          document.cookie =
            name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + (domain ? '; domain=' + domain : '');
        });
      }
    });
  }

  function marketingDeclined() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
    return privacy.currentVisitorConsent().marketing === 'no';
  }

  function checkConsent() {
    if (marketingDeclined()) clearKlaviyoCookies();
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) checkConsent();
    });
  }
  document.addEventListener('visitorConsentCollected', (event) => {
    if (event.detail && event.detail.marketingAllowed === false) clearKlaviyoCookies();
  });

  class SfCookieSettings extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', () => {
        if (window.privacyBanner) window.privacyBanner.showPreferences();
      });
      this.tries = 0;
      this.check();
    }
    check() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        this.hidden = false;
        return;
      }
      // Shopify loads the banner script after the theme's, so look again for up to ten seconds.
      if (this.tries++ < 20) setTimeout(() => this.check(), 500);
    }
  }
  if (!customElements.get('sf-cookie-settings')) customElements.define('sf-cookie-settings', SfCookieSettings);
})();
